import { States } from 'safe'
import {
  SalesDeliveryNotesTypes,
  SET_HISTORIC_DELIVERY_NOTES,
} from '../actions/actionTypes'

const initialState: States.HistoricSaleDeliveryNotes = {
  deliveryNotes: [],
  numberOfPages: 0,
}

export default (
  state = initialState,
  action: SalesDeliveryNotesTypes
): States.HistoricSaleDeliveryNotes => {
  switch (action.type) {
    case SET_HISTORIC_DELIVERY_NOTES:
      return {
        ...action.payload,
      }
    default:
      return state
  }
}
